/**
 * OpenAPI generator for oRPC
 * @package @app/api
 */

import { OpenAPIGenerator } from '@orpc/openapi';
import { ZodToJsonSchemaConverter } from '@orpc/zod';
import { router } from '../routers';

export const openAPIGenerator = new OpenAPIGenerator({
  schemaConverters: [new ZodToJsonSchemaConverter()],
});

export async function generateOpenAPISpec() {
  return openAPIGenerator.generate(router, {
    info: {
      title: 'Matrix API',
      version: '1.0.0',
      description: 'Foundry Web Template API - Built with oRPC',
    },
    servers: [
      {
        url: process.env.VITE_API_URL || process.env.NEXT_PUBLIC_API_URL || 'http://localhost:3001',
        description: 'API Server',
      },
    ],
  });
}
